import WeatherContainer from "../weather";

const HomeContainer = () => {
  return (
    <div className="animation-fade">
      <WeatherContainer />
    </div>
  );
};

export default HomeContainer;
